

<section class="toggle-form change-request-item" [ngClass]="{'active': isCreateChangeRequestItemSliderOpen}">
    <div class="formwrap">
        <p-panel header="Create Change Request Item">
            <ng-template pTemplate="icons">
                <p-button appPreventDoubleClick styleClass="p-button-text" id="CreateChangeRequestItemCloseButton" type="button" label="Close"
                    (debounceClick)="confirm()" class="align-right"></p-button>
            </ng-template>
            <form [formGroup]="changeRequestItemForm">
                <div *ngIf="errorMessages.length > 0">
                    <p-messages severity="error">
                        <ng-template pTemplate>
                            <span class="p-message-icon pi pi-times-circle"></span>
                            <span class="p-ml-2">The Change Request Item could not be saved. Please correct the
                                following issues to continue</span>
                            <ul>
                                <li *ngFor="let errorText of errorMessages">{{ errorText }}</li>
                            </ul>
                        </ng-template>
                    </p-messages>
                </div>
                <div class="general-tab">
                    <div class="fields-row">
                        <bpt-text-input [ngClass]="{'error-highlight' : mandatoryFields.description}" [rows]="5"
                            [cols]="150" formControlName="description" [highlightAllOnFocus]="true" [multiLine]="true"
                            id="CreateChangeRequestItemDescription" label="Description*"></bpt-text-input>
                    </div>
                    <div class="fields-row">
                        <bpt-text-input  [rows]="5"
                            [cols]="150" formControlName="benefitOfChange" [highlightAllOnFocus]="true" [multiLine]="true"
                            id="CreateChangeRequestItemBenefitOfChange" label="Benefit of Change"></bpt-text-input>
                    </div>
                    <div class="field-title field-required">
                        <label for="ChangeDue"><b>When is the change due?</b></label>
                    </div>
                    <p-radioButton name="changeDue" id="CreateChangeRequestItemChangeDueASAP" value="1"
                        aria-selected="true" formControlName="changeDue"></p-radioButton>&nbsp;
                    <label for="CreateChangeRequestItemChangeDueASAP">As Soon As Possible</label> &nbsp;&nbsp;&nbsp;
                    <p-radioButton name="changeDue" id="CreateChangeRequestItemChangeDueNPR" value="2"
                        formControlName="changeDue"></p-radioButton>&nbsp;
                    <label for="CreateChangeRequestItemChangeDueNPR">Next Periodic Review</label>
                    <br>
                    <br>
                    <div class="fields-row">
                        <bpt-dropdown label="Additional Notified Users" [options]="userList" [editable]="false"
                            placeholder="Select Users" id="CreateChangeRequestItemAdditionalNotifiedUsers"
                            [showClear]="true" [showFilter]="true" [multiSelect]="true" [valueField]="valueField"
                            [labelField]="labelField" formControlName="additionalNotifiedUsers">
                        </bpt-dropdown>
                        <div></div>
                    </div>
                </div>
                <div>
                    <p-button appPreventDoubleClick label="Submit" type="submit" id="CreateChangeRequestItemSave" class="align-right"
                        (debounceClick)="createChangeRequestItem()">
                    </p-button>
                </div>
            </form>
        </p-panel>
    </div>
</section>